"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeSlug = void 0;
/**
 * Generates a unique slug based on a supplied title. An increment will
 * to the name if a conflict exists in the index.
 * @param title The title used to generate the url friendly slug
 * @param currentId An optional ID used to filter out the existing result from potential conflicts.
 */
var makeSlug = function (_a) {
    var title = _a.title, currentId = _a.currentId, lookupMatches = _a.lookupMatches;
    return __awaiter(void 0, void 0, void 0, function () {
        var slug, matches, slugs, slugUnique, exactMatch, increments, increment, finalSlug;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    slug = (title !== null && title !== void 0 ? title : 'unknown')
                        .toLowerCase()
                        .split(' ')
                        .map(function (w) { return w.replace(/[^0-9a-z]/gi, ''); })
                        .join('-');
                    return [4 /*yield*/, lookupMatches({ slug: slug })];
                case 1:
                    matches = (_b = (_c.sent())) !== null && _b !== void 0 ? _b : [];
                    slugs = matches.map(function (m) { var _a; return (_a = m.indexSortKey) !== null && _a !== void 0 ? _a : ''; });
                    slugUnique = slugs.filter(function (s) { return s === slug; }).length === 1;
                    exactMatch = matches.filter(function (m) { return m.partitionKey === currentId; })[0];
                    if (currentId && (exactMatch === null || exactMatch === void 0 ? void 0 : exactMatch.indexSortKey) === slug && slugUnique) {
                        return [2 /*return*/, slug];
                    }
                    increments = slugs
                        .map(function (slug) { var _a; return parseInt((_a = slug.split('-').reverse()[0]) !== null && _a !== void 0 ? _a : '0', 0); })
                        .map(function (n, i) { return (isNaN(n) ? i : n); });
                    increment = Math.max.apply(Math, increments);
                    finalSlug = [slug, increment > 0 ? increment + 1 : null]
                        .filter(function (i) { return i; })
                        .join('-');
                    return [2 /*return*/, finalSlug];
            }
        });
    });
};
exports.makeSlug = makeSlug;
